import { HttpClient, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, BulkUploadDto, BulkUploadFileLineDto, BulkUploadSettingDto, DynamicFormDto, DynamicPayloadDto, FileUploadDto, MemberDto, ResultListDto } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpBulkUploadService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/bulk_upload', authService);
	}
	get(id: number): Observable<BulkUploadDto>{
		return super.doGet(true, `/${id}`)
	}
	getAll(type: string): Observable<BulkUploadDto[]>{
		return super.doGet(true, `/${type}/list`)
	}
	getOptions(type: string): Observable<BulkUploadSettingDto[]>{
		return super.doGet(true, `/${type}/options`)
	}
	create(type: string, payload: BulkUploadDto): Observable<BulkUploadDto>{
		return super.doPost(true, `/${type}/`, payload);
	}
	getFileContents(fileId: number, showOnlyFailed: boolean, pageIndex: number, pageSize: number): Observable<ResultListDto<BulkUploadFileLineDto>>{
		return super.doGet(true, `/file:${fileId}/lines?showOnlyFailed=${showOnlyFailed}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
	}
}
